

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {
    PriceCorridor,
    ScenarioAnalysisParams,
    ScenarioNameWithFilters,
    ScenarioNameWithParams,
    ScenariosWithFilters,
    SelectBox,
    SelectMarket,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilter,
    CompetitorsPriceStrategies,
    GetTaskInfo,
    IntervalOfUltimateElasticity,
    ScenarioAnalysisFilters, SkuFilter,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
    UVWSpreadParams,
    XYZSpreadParams,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import _ from 'lodash';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"

@Component({
    components: {
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        HintsContainer,
        CollapseCard,
        CSelect,
        SwitchWithLabel,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
    },
    methods: {
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
    },
})
export default class ScenarioAnalysisPage extends Mixins(LocalData, Toast, Http) {
    scenarioName: string = '';
    scenarioNameIsUniqueErrorText: string = '';
    scenarioNewNameIsUniqueErrorText: string = '';
    scenarioIndexToDelete: number = -1;
    scenarioIndexToRename: number = -1;
    scenarioNameToDelete: string = '';
    scenarioNameToRename: string = '';
    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('regular.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('regular.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('regular.common.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('regular.common.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('regular.common.all') as string}],
        psegemnts: [],
    };

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];
    searchable: boolean = true;
    debounceMinRetailPrice!: () => void;
    marginalErrorText = '';
    marginalSkuErrorText = '';

    taskData: TaskAndFile | null = null;
    firstDate: number = 0;
    lastDate: number = 0;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    isDataRangeCalculated: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    showDataRange: boolean = false;
    dropDownOpen = false;
    // tslint:disable-next-line: ban-types
    onDropdownClosed: Function | null = null;
    scenarioArray: ScenarioNameWithParams[] = [];
    showDeleteScenarioModal: boolean = false;
    showRenameScenarioModal: boolean = false;
    tempScenario: ScenarioNameWithParams = {scenarioName: '', scenarioParams: this.getScenarioAnalysisDefaultData()}
    useFindKviRecommendsParam: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;

    private useBrutForcingParams: boolean = false;
    private saveAfterOptimize: boolean = false;
    private optimizationDiff: number = 0.0;
    private actualProfitability: number | null = null;
    private showSku: boolean = false;
    private regularPricesProfitability: number | null = null;
    private activePurchasePriceSuppliers: boolean = true;
    private activePurchasePriceSuppliersWithRemains: boolean = true;
    private disableAllPurchaseOptionsIfActivePurchasePriceSuppliers: boolean = false;
    private disableAllPurchaseOptionsIfActivePurchasePriceSuppliersForRemains: boolean = false;
    private purchasePriceSuppliersWithRemains: boolean = false;
    private countAtMaxPurchasePrice = true;
    private countAtFuturePurchasePrice = false;
    private countByAvgPurchasePrice = false;
    private calcPurchasePriceByClusters = false;
    private useEmptyRemains = false;

    onPriceFamiliesChange(scenario: any) {
        // Если "Расчёт по Price Families" выключается, автоматически выключаем "Жёсткий Price Families"
        if (!scenario.scenarioParams.priceFamilies) {
            scenario.scenarioParams.hardPriceFamilies = false;
        }
        this.saveScenarioAnalysis();
    }

    mounted() {
        if (this.$scenario.selectMarket.id !== -1) {
            this.loadScenarios();
            const self = this;
            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.updateSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
            (this.$refs.productSegmentsRef as any).toggleLoading(true);
            (this.$refs.categoryStrategyRef as any).toggleLoading(true);
            this.getCategoryInfo();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsGroup();
            self.loadProductsSubcategories();
            self.loadProductSegments();
            setTimeout(() => { (this.$refs.categoryStrategyRef as any).toggleLoading(false); }, Math.floor(Math.random() * (800 - 300 + 1)) + 300);
        }

        EventBus.$on('calc', this.onCalcEventReceived);
        EventBus.$on('tradingNetChanged', this.updateSelectMarket);
    }

    addScenarioToArray() {
        const obj = JSON.parse(JSON.stringify(this.tempScenario.scenarioParams));
        const element: ScenarioNameWithParams = {
            scenarioName: this.scenarioName,
            scenarioParams: obj,
        }
        this.scenarioArray.push(element);
        this.scenarioName = '';
    }

    beforeDeleteScenarioDialog(scenarioIndex: number, scenarioName: string) {
        this.showDeleteScenarioModal = true
        this.scenarioIndexToDelete = scenarioIndex;
        this.scenarioNameToDelete = scenarioName;
    }

    beforeRenameScenarioDialog(scenarioIndex: number, scenarioName: string) {
        this.showRenameScenarioModal = true
        this.scenarioIndexToRename = scenarioIndex;
        this.scenarioNameToRename = scenarioName;
    }

    removeScenario(index: number) {
        this.scenarioArray.splice(index, 1);
        this.saveScenario();
    }

    renameScenario(index: number) {
        this.scenarioArray[index].scenarioName = this.scenarioNameToRename;
    }

    showScenarios(): boolean {
        return this.scenarioArray.length > 0;
    }

    scenarioNameIsEmpty(): boolean {
        return this.scenarioName.trim() === '';
    }

    scenarioNewNameIsEmpty(): boolean {
        return this.scenarioNameToRename.trim() === '';
    }

    disableCreateScenarioButton(): boolean {
        return this.scenarioNameIsEmpty() || this.scenarioNameIsUnique()
    }

    disableRenameScenarioButton(): boolean {
        return this.scenarioNewNameIsEmpty() || this.scenarioNewNameIsUnique()
    }

    scenarioNameIsUnique(): boolean {
        const counter: { [key: string]: number } = {};
        counter[this.scenarioName] = 1

        this.scenarioArray.forEach((item) => {
            if (item.scenarioName != null) {
                if (counter.hasOwnProperty(item.scenarioName)) {
                    counter[item.scenarioName] = counter[item.scenarioName] + 1
                } else {
                    counter[item.scenarioName] = 1
                }
            }
        });
        let findCounter = false
        for (const key in counter) {
            if (counter[key] > 1) {
                findCounter = true
            }
        }
        return findCounter;
    }

    scenarioNewNameIsUnique(): boolean {
        const counter: { [key: string]: number } = {};
        counter[this.scenarioNameToRename] = 1
        this.scenarioArray.forEach((item) => {
            if (item.scenarioName != null) {
                if (counter.hasOwnProperty(item.scenarioName)) {
                    counter[item.scenarioName] = counter[item.scenarioName] + 1
                } else {
                    counter[item.scenarioName] = 1
                }
            }
        });
        let findCounter = false
        for (const key in counter) {
            if (counter[key] > 1) {
                findCounter = true
            }
        }
        return findCounter;
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('tradingNetChanged', this.updateSelectMarket);
    }

    created() {
        this.httpLoadModuleHints('ScenarioAnalysisPage').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
        const self = this;
        this.debounceMinRetailPrice = _.debounce(() => {
            self.checkPriceCorridorMinVal()
        }, 500);
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$scenario.categoryOfProduct = null;
                this.$scenario.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.formatSelected = null;
                this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.clusterSelected = null;
                this.$scenario.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.category:
                this.$scenario.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.formatSelected = null;
                this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.clusterSelected = null;
                this.$scenario.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.$scenario.formatSelected = null;
                this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.clusterSelected = null;
                this.taskInfo.psegemnts = [];
                this.$scenario.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$scenario.formatSelected = null;
                this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.clusterSelected = null;
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$scenario.clusterSelected = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegments();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.$scenario.clusterSelected = null;
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegments();
                this.getClusterInfo();
                break;
        }

        this.resetActualProfitability();
        this.resetRegularPricesProfitability();
        this.resetScenarios();
    }

    updateProductGroup(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$scenario.groupOfProduct) {
            this.resetPriceCorridor();
            this.resetDataRange();
            this.$scenario.groupOfProduct = groupOfProduct;
            this.saveScenarioAnalysis();
            this.resetData(TaskInfoFilterType.group);
        }
    }

    updateCluster(cluster: number | null) {
        if (cluster !== this.$scenario.clusterSelected) {
            this.resetPriceCorridor();
            this.$scenario.clusterSelected = cluster;
            this.resetData(TaskInfoFilterType.cluster);
            this.saveScenarioAnalysis();
        }
    }

    updateProductCategory(category: number | null) {
        if (category !== this.$scenario.categoryOfProduct) {
            this.resetPriceCorridor();
            this.$scenario.categoryOfProduct = category;
            this.resetData(TaskInfoFilterType.category);
            this.saveScenarioAnalysis();
        }
    }

    updateFormat(format: number | null) {
        if (format !== this.$scenario.formatSelected) {
            this.resetPriceCorridor();
            this.$scenario.formatSelected = format;
            this.resetData(TaskInfoFilterType.format);
            this.saveScenarioAnalysis();
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scenario.regionSelected)) {
            this.resetPriceCorridor();
            this.$scenario.regionSelected = list;
            this.onDropdownClosed = () => {
                this.saveScenarioAnalysis();
                this.resetData(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$scenario.regionSelected[0] === 0) {
            this.$scenario.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scenario.buyerSegmentsList)) {
            this.resetPriceCorridor();
            this.$scenario.buyerSegmentsList = list;
            this.saveScenarioAnalysis();
        } else if (this.$scenario.buyerSegmentsList[0] === 0) {
            this.$scenario.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scenario.subcategories)) {
            this.resetPriceCorridor();
            this.$scenario.subcategories = list;
            this.onDropdownClosed = () => {
                this.saveScenarioAnalysis();
                this.resetData(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$scenario.subcategories[0] === 0) {
            this.$scenario.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scenario.productSegments)) {
            this.resetPriceCorridor();
            this.$scenario.productSegments = list;
            this.onDropdownClosed = () => {
                this.saveScenarioAnalysis();
                this.resetData(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$scenario.productSegments[0] === 0) {
            this.$scenario.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scenario.seasonSelected)) {
            this.resetPriceCorridor();
            this.$scenario.seasonSelected = list;
            this.onDropdownClosed = () => {
                this.saveScenarioAnalysis();
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$scenario.seasonSelected[0] === 0) {
            this.$scenario.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    resetPriceCorridor() {
        this.$scenario.changePriceCorridor = false;
    }

    resetDataRange() {
        this.firstDate = 0;
        this.lastDate = 0;
    }

    resetScenarios() {
        this.scenarioArray = [];
        this.loadScenarios();
    }

    updateSelectMarket(market: SelectMarket) {
        if (this.$scenario.selectMarket == null || this.$scenario.selectMarket.id !== market.id) {
            this.resetScenarioAnalysisData();
            this.$scenario.selectMarket = market;
            this.initTask();
            this.saveScenarioAnalysis();
            this.resetDataRange();
            this.resetScenarios();
            this.resetActualProfitability();
            this.resetRegularPricesProfitability();
            this.$scenario.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}
        }
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$scenario.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
                || status === 'EmptyData'
                || status === 'ExecutionException'
                || status.includes('Error'));
    }

    selectData(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$scenario.seasonSelected.length === 0 || (this.$scenario.seasonSelected.length === 1 && this.$scenario.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.seasonSelected)!!;
        const selectRegions: number[] = (this.$scenario.regionSelected.length === 0 || (this.$scenario.regionSelected.length && this.$scenario.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$scenario.buyerSegmentsList.length === 0 || (this.$scenario.buyerSegmentsList.length && this.$scenario.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.buyerSegmentsList)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    priceCorridorInfo(params: ScenarioAnalysisParams) {
        if (!params.changePriceCorridor) {
            return;
        }
        if (params.selectMarket.id === -1 || params.categoryOfProduct == null) {
            return;
        }
        this.isPriceCorridorCalculated = true;

        const filters = this.getScenarioFilter(params);
        this.httpPostPriceCorridor(filters)
                .then((r) => {
                            params.priceCorridor = r.data;
                            this.isPriceCorridorCalculated = false;
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadPriceCorridorFailed') as string);
                    this.$log.error('Error occurred [load price corridor]', e);
                    this.isPriceCorridorCalculated = false;
                });
    }

    disableCalcPurchasePriceByClustersCheckbox(params: ScenarioAnalysisParams) {
        if (!params.countByAvgPurchasePrice) {
            params.calcPurchasePriceByClusters = false;
            params.useArrivalDate = false;
        }
        if (params.countByAvgPurchasePrice) {
            params.countAtFuturePurchasePrice = false;
        }
    }

    disableCountByAvgPurchasePriceAndCalcPurchasePriceByClustersCheckboxes(params: ScenarioAnalysisParams) {
        if (params.countAtMaxPurchasePrice) {
            params.countByAvgPurchasePrice = false;
        }
    }

    disableCountByAvgPurchasePriceAndCalcPurchasePriceByClustersCheckboxesForFuturePrice(params: ScenarioAnalysisParams) {
        if (params.countAtFuturePurchasePrice) {
            params.countByAvgPurchasePrice = false;
            params.calcPurchasePriceByClusters = false;
        }
    }

    dataRangeInfo(params: ScenarioAnalysisParams) {
        if (!this.showDataRange) {
            return;
        }
        if (this.$scenario.selectMarket.id === -1 || this.$scenario.categoryOfProduct == null) {
            this.firstDate = 0;
            this.lastDate = 0;
            return;
        }
        this.isDataRangeCalculated = true;

        const filters = this.getScenarioFilter(params)
        this.httpPostDataRange(filters)
                .then((r) => {
                            if (r.data.firstDate == null && r.data.lastDate == null) {
                                this.firstDate = 0;
                                this.lastDate = 0;
                                this.showInfo(this.$t('regular.errors.getDateRangeNoData') as string);
                                this.isDataRangeCalculated = false;
                            } else {
                                this.firstDate = r.data.firstDate;
                                this.lastDate = r.data.lastDate;
                                this.isDataRangeCalculated = false;
                            }
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.getDateRangeFailed') as string);
                    this.$log.error('Error occurred [load data range]', e);
                    this.isDataRangeCalculated = false;
                });
    }

    checkPriceCorridorMinVal() {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filters: BaseFilter = {
            category: this.$scenario.categoryOfProduct,
            storeCluster: this.$scenario.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$scenario.formatSelected,
            tradingId: this.$scenario.selectMarket.id,
            calculationDepth: +this.$scenario.calculationDepth,
            calculationDay: +this.$scenario.calculationDay,
            groupOfProduct: this.$scenario.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments)!!,
        };

        this.httpPostMinRetailPrice(filters)
                .then((r) => {
                            const data = r.data;
                            this.$log.debug('Min retail price', data);
                            if (data.minRetailPrice !== null && this.$scenario.priceCorridor.min < data.minRetailPrice) {
                                this.showInfo(this.$t('regular.validation.lowerBoundBelowMinRetail') as string + data.minRetailPrice)
                            }
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadMinRetailPriceFailed') as string)
                });
    }

    initTask() {
        if (this.$scenario.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.groupSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        (this.$refs.groupOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);

        this.$scenario.categoryOfProduct = null;
        this.$scenario.clusterSelected = null;
        this.$scenario.formatSelected = null;
        this.$scenario.groupOfProduct = null;
        this.$scenario.subcategories = [];
        this.$scenario.productSegments = []
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        const self = this;
        this.getCategoryInfo(() => {
            self.loadProductsGroup();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsSubcategories();
            self.loadProductSegments();
        });
    }

    loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupOfProductRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.groups.length > 0) {
                        this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.groupsOfProduct.unshift({value: null, label: this.$t('regular.common.all') as string});
                    } else {
                        this.$scenario.groupOfProduct = null;
                        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
                    }
                })
                .catch((e) => {
                })
    }

    loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.subcategoriesRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
                })
                .catch((e) => {
                })
    }

    getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupSelectedRef as any).toggleLoading(false);
                        (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.categories.length > 0) {
                        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.categoryOptions.unshift({value: null, label: this.$t('regular.common.selectCategory') as string});
                    } else {
                        this.$scenario.categoryOfProduct = null;
                        this.taskInfo.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                        this.resetData(TaskInfoFilterType.category);
                    }
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                    this.taskInfo.storeFormatOptions = [{
                        value: null,
                        label: this.$t('regular.common.all') as string,
                    }, ...this.taskInfo.storeFormatOptions];

                })
                .catch((e) => {
                });
    }

    getBuyerSegment() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                })

    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                    this.taskInfo.clusterOptions = [{
                        value: null,
                        label: this.$t('regular.common.all') as string,
                    }, ...this.taskInfo.clusterOptions];

                })
                .catch((e) => {
                });
    }

    loadProductSegments() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
                .then((data) => {
                    setTimeout(() => {
                        (this.$refs.productSegmentsRef as any).toggleLoading(false);
                    }, 250);
                    const filterData = data.data;
                    this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                        return {
                            label: i.name,
                            value: i.id,
                        }
                    });
                    this.taskInfo.psegemnts.unshift({value: 0, label: this.$t('regular.common.all') as string})
                })
                .catch((e) => {
                });
    }

    calcButtonDisable(): boolean {
        return this.scenarioArray.length === 0 || this.useBrutForcingParams || this.useFindKviRecommendsParam;
    }

    paramsButtonDisable(): boolean {
        return this.scenarioArray.length === 0 || !this.useBrutForcingParams || this.useFindKviRecommendsParam;
    }

    resetKVIparams() {
        this.useFindKviRecommendsParam = false;
        this.$scenario.percentageOfRecommendsKviCount = 10;
        this.$scenario.useSegmentsPriceInSearchKVIRecParam = false;
        this.$scenario.saveKviSign = false;
    }

    calcActualProfitability() {
        if (this.$scenario.selectMarket.id === -1 || this.$scenario.categoryOfProduct == null || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
                .then((number) => {
                    this.actualProfitability = number.data;
                    this.isActualProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.calcActualProfitFailed') as string);
                    this.isActualProfitabilityCalculated = false;
                })
    }

    calcRegularPricesProfitability() {
        if (this.$scenario.selectMarket.id === -1 || this.$scenario.categoryOfProduct == null || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetRegularPricesProfitability(filter)
                .then((number) => {
                    this.regularPricesProfitability = number.data;
                    this.isRegularPricesProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.calcRegularProfitFailed') as string);
                    this.isRegularPricesProfitabilityCalculated = false;
                })
    }

    refreshAndDisableAllPurchaseOptionsAfterPurchasePriceSuppliers(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$scenario.purchasePriceSuppliersWithRemains = false;
            this.$scenario.countAtMaxPurchasePrice = true;
            this.$scenario.countAtFuturePurchasePrice = false;
            this.$scenario.countByAvgPurchasePrice = false;
            this.$scenario.calcPurchasePriceByClusters = false;
            this.$scenario.useEmptyRemains = false;
            this.$scenario.countByAvgPurchasePrice = false;
            this.activePurchasePriceSuppliersWithRemains = false;
            this.disableAllPurchaseOptionsIfActivePurchasePriceSuppliers = true;
        } else {
            this.disableAllPurchaseOptionsIfActivePurchasePriceSuppliers = false;
            this.activePurchasePriceSuppliersWithRemains = true;
        }
    }

    refreshAndDisableAllPurchaseOptionsAfterPurchasePriceSuppliersWithRemains(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$calc.purchasePriceSuppliers = false;
            this.$calc.countAtMaxPurchasePrice = true;
            this.$calc.countAtFuturePurchasePrice = false;
            this.$calc.countByAvgPurchasePrice = false;

            this.activePurchasePriceSuppliers = false;
            this.disableAllPurchaseOptionsIfActivePurchasePriceSuppliersForRemains = true;
        } else {
            this.activePurchasePriceSuppliers = true;
            this.disableAllPurchaseOptionsIfActivePurchasePriceSuppliersForRemains = false;
        }
    }

    calc() {
        if (this.useBrutForcingParams && this.optimizationDiff < 0.0) {
            this.showError(this.$t('regular.validation.growthPercentPositive') as string);
            return;
        }
        if (this.useBrutForcingParams) {
            this.showInfo(this.$t('regular.notifications.optimalParamsStarted') as string);
        } else {
            this.showInfo(this.$t('regular.notifications.calcStarted') as string);
        }
        const selectRegions: number[] = (this.$scenario.regionSelected.length === 0 || (this.$scenario.regionSelected.length && this.$scenario.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.regionSelected)!!;
        const scenarios: ScenarioNameWithFilters[] = []
        this.scenarioArray.forEach((element) => {
            const params = this.getScenarioFilter(element.scenarioParams)
            const filters: ScenarioNameWithFilters = {
                scenarioName: element.scenarioName,
                scenarioParams: params,
            }
            scenarios.push(filters)
        });
        const resultParams: ScenariosWithFilters = {
            tradingId: this.$scenario.selectMarket.id,
            groupOfProduct: this.$scenario.groupOfProduct,
            categoryOfProduct: this.$scenario.categoryOfProduct,
            storeFormat: this.$scenario.formatSelected,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
            storeCluster: this.$scenario.clusterSelected,
            storeRegionValues: selectRegions,
            categoryStrategy: this.$scenario.categoryStrategy.value,
            scenarioFilters: scenarios,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments)!!,
        }

        // Сохраняем параметры сценариев перез запуском пакетных расчетов
        this.httpSaveScenarioAnalysis(resultParams)
                .then((r) => {
                            this.$log.debug(this.$t('regular.notifications.paramsSaved') as string, r.data);
                        },
                )
                .catch((e) => {
                    this.$log.error(this.$t('regular.errors.saveScenarioParamsFailed') as string, e)
                });
        this.saveScenarioAnalysis();
        this.httpRunPackageScenarioTask(resultParams)
                .then((r) => {
                            this.$log.debug('Create task', r.data);
                            EventBus.$emit('onCalcParamsSaved')
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.startCalcFailed') as string);
                    this.$log.error('Error occurred on creating scenario calc', e)
                });
    }

    saveScenario() {
        const selectRegions: number[] = (this.$scenario.regionSelected.length === 0 || (this.$scenario.regionSelected.length && this.$scenario.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.regionSelected)!!;
        const scenarios: ScenarioNameWithFilters[] = []
        this.scenarioArray.forEach((element) => {
            const params = this.getScenarioFilter(element.scenarioParams)
            const filters: ScenarioNameWithFilters = {
                scenarioName: element.scenarioName,
                scenarioParams: params,
            }
            scenarios.push(filters)
        });
        const resultParams: ScenariosWithFilters = {
            tradingId: this.$scenario.selectMarket.id,
            groupOfProduct: this.$scenario.groupOfProduct,
            categoryOfProduct: this.$scenario.categoryOfProduct,
            storeFormat: this.$scenario.formatSelected,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments)!!,
            storeCluster: this.$scenario.clusterSelected,
            storeRegionValues: selectRegions,
            categoryStrategy: this.$scenario.categoryStrategy.value,
            scenarioFilters: scenarios,
        }
        this.httpSaveScenarioAnalysis(resultParams)
                .then((r) => {
                            this.$log.debug(this.$t('regular.notifications.paramsSaved') as string, r.data);
                            this.showInfo(this.$t('regular.notifications.paramsSaved') as string);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.saveScenarioParamsFailed') as string);
                    this.$log.error(this.$t('regular.errors.saveScenarioParamsFailed') as string, e)
                });
    }

    loadScenarios() {
        if (this.$scenario.categoryOfProduct != null && this.$scenario.categoryOfProduct > 0) {
            const selectRegions: number[] = (this.$scenario.regionSelected.length === 0 || (this.$scenario.regionSelected.length && this.$scenario.regionSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$scenario.regionSelected)!!;
            const resultParams: ScenariosWithFilters = {
                tradingId: this.$scenario.selectMarket.id,
                groupOfProduct: this.$scenario.groupOfProduct,
                categoryOfProduct: this.$scenario.categoryOfProduct,
                storeFormat: this.$scenario.formatSelected,
                // tslint:disable-next-line: no-non-null-assertion
                subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
                // tslint:disable-next-line: no-non-null-assertion
                productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments)!!,
                storeCluster: this.$scenario.clusterSelected,
                storeRegionValues: selectRegions,
                categoryStrategy: this.$scenario.categoryStrategy.value,
            }
            this.httpLoadScenarios(resultParams)
                    .then((r) => {
                                r.data.forEach((item) => {
                                    const scenario = this.getScenarioAnalysisDefaultData()
                                    this.applyScenarioAnalysisFilters(scenario, item.scenarioParams)
                                    const element: ScenarioNameWithParams = {
                                        scenarioName: item.scenarioName,
                                        scenarioParams: scenario,
                                    }
                                    this.scenarioArray.push(element);
                                });
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.loadScenariosByFiltersFailed') as string);
                        this.$log.error(this.$t('regular.errors.loadScenariosByFiltersFailed') as string, e)
                    });
        }
    }

    updatePriceCorridor(params: ScenarioAnalysisParams) {
        this.priceCorridorInfo(params);
        this.saveScenarioAnalysis();
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    newProductLifespanInDaysValidate(newProductLifespanInDays: number): boolean {
        if (newProductLifespanInDays != null) {
            return newProductLifespanInDays >= 0 && newProductLifespanInDays <= 100;
        }
        return false;
    }

    countPriceSegmentsValidate(countSegments: number): boolean {
        return countSegments.toString() !== '' && countSegments > 0;
    }

    getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$scenario.selectMarket.id,
            categories: this.$scenario.categoryOfProduct == null || this.$scenario.categoryOfProduct <= 0 ? null : [this.$scenario.categoryOfProduct],
            groups: this.$scenario.groupOfProduct == null || this.$scenario.groupOfProduct <= 0 ? null : [this.$scenario.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$scenario.subcategories, true),
            segments: null,
            storeFormat: this.$scenario.formatSelected == null || this.$scenario.formatSelected <= 0 ? null : [this.$scenario.formatSelected],
            storeCluster: this.$scenario.clusterSelected == null || this.$scenario.clusterSelected <= 0 ? null : [this.$scenario.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    getScenarioFilter(params: ScenarioAnalysisParams): ScenarioAnalysisFilters {
        const selectSeasons: number[] = (this.$scenario.seasonSelected.length === 0 || (this.$scenario.seasonSelected.length === 1 && this.$scenario.seasonSelected[0] === 0)) ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.seasonSelected)!!;
        const selectRegions: number[] = (this.$scenario.regionSelected.length === 0 || (this.$scenario.regionSelected.length && this.$scenario.regionSelected[0] === 0)) ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$scenario.buyerSegmentsList.length === 0 || (this.$scenario.buyerSegmentsList.length && this.$scenario.buyerSegmentsList[0] === 0)) ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$scenario.buyerSegmentsList)!!;
        const allCheck = params.allCheck;
        const discountPrice = params.discountPrice;
        const pennies = params.pennies;
        const countAtMaxPurchasePrice = params.countAtMaxPurchasePrice;
        const countAtFuturePurchasePrice = params.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = params.allNewPricesWithoutPennies;
        const allClaster = params.allClaster;
        const xyzChecked = params.xyzChecked;
        const uvwChecked = params.uvwChecked;
        return {
            individualCommonParams: Object.create(null),
            productCodesForAddKvi: [],
            productCodesForDeleteKvi: [],
            productCodesForAddCtmPurpose: [],
            productCodesForDeleteCtmPurpose: [],
            productRangesAndInternalCodes: [],
            allCheck,
            discountPrise: discountPrice,
            pennies,
            countAtLastPurchasePrice: false,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: params.selectCoefficent.value.k1,
            coefficientK2: params.selectCoefficent.value.k2,
            category: this.$scenario.categoryOfProduct,
            storeCluster: this.$scenario.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: params.uvwParams,
            spreadXYZParams: params.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$scenario.formatSelected,
            tradingId: this.$scenario.selectMarket.id,
            calculationDepth: +params.calculationDepth,
            correlation: params.correlation ? params.correlation : 0.7,
            highElasticity: params.highElasticity ? params.highElasticity : -0.5,
            intervalOfUltimateElasticity: params.intervalOfUltimateElasticity,
            competitorsPricesParams: params.competitorsPrices,
            kviStrategy: params.kviStrategy.value,
            percentageOfCompetitorsPrice: params.percentageOfCompetitorsPrice,
            marginalProfitability: params.marginalProfitability,
            marginalProfit: params.marginalProfit,
            maxMarginalProfit: params.maxMarginalProfit != null ? params.maxMarginalProfit : 100,
            marginalPriceDifference: params.marginalPriceDifference,
            newProductLifespanInDays: params.newProductLifespanInDays,
            calculationDay: +params.calculationDay,
            priceCorridor: params.priceCorridor,
            changePriceCorridor: params.changePriceCorridor,
            priceIncreaseLimit: params.priceIncreaseLimit,
            fixLowerBorder: params.fixLowerBorder,
            depthToPurchasePrice: params.depthToPurchasePrice,
            priceFamilies: params.priceFamilies,
            hardPriceFamilies: params.hardPriceFamilies,
            groupOfProduct: this.$scenario.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: params.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
            useCompetitorsPrices: params.useCompetitorsPrices,
            byPromoPrices: params.byPromoPrices,
            competitorsPricePeriod: params.competitorsPricePeriod,
            competitorsCodes: [],
            competitorsPriceMethod: params.competitorsPriceMethod.value,
            competitorsPriceAdjustment: params.competitorsPriceAdjustment,
            competitorsInfluencesCoef: params.competitorsInfluencesCoef,
            competitorsMinimumProfit: params.competitorsMinimumProfit,
            competitorsMaximumProfit: params.competitorsMaximumProfit != null ? params.competitorsMaximumProfit : 100,
            competitorsControlParam: params.competitorsControlParam,
            competitorsPriceStrategy: params.competitorsPriceStrategy.value,
            daysToPriceChangeStart: params.daysToPriceChangeStart && params.daysToPriceChangeStart > 0 
                ? params.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: params.daysToPriceChangeFinish && params.daysToPriceChangeFinish > 0 
                ? params.daysToPriceChangeFinish 
                : null,
            roundKviCompetitorPrice: params.roundKviCompetitorPrice,
            calculateByRegression: !params.calculateByElasticity,
            recalculateCtm: params.recalculateCtm,
            priceChangeLimit: params.priceChangeLimit,
            priceChangeLimitKvi: params.priceChangeLimitKvi,
            priceChangeLimitComp: params.priceChangeLimitComp,
            useBrutForcingParams: this.useBrutForcingParams,
            saveAfterOptimize: this.saveAfterOptimize,
            optimizationDiff: this.optimizationDiff,
            calculatePYR: params.calculatePYR,
            periodPriceIncreaseLimit: params.periodPriceIncreaseLimit,
            period: params.period.value,
            newProductPriceStrategy: params.newProductPriceStrategy.value,
            priceGap: params.priceGap,
            priceGapCtmPc: params.priceGapCtmPc,
            findAutomaticallyPriceSegments: params.findAutomaticallyPriceSegments,
            countPriceSegments: params.countPriceSegments,
            promoCalc: false,
            categoryStrategy: this.$scenario.categoryStrategy.value,
            roundPricesWithEqualCompStrategy: params.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: params.calculateCompAllowedDeviation,
            useCompElasticity: params.useCompElasticity,
            minProfitKVI: params.minProfitKVI,
            maxProfitKVI: params.maxProfitKVI != null ? params.maxProfitKVI : 100,
            randomPennies: params.randomPennies,
            manualPennies: params.manualPennies,
            forecastAccuracy: params.forecastAccuracy,
            countAtMaxPurchasePrice,
            percentileType: params.percentileType.value,
            useAllProductBatchNumbers: params.useAllProductBatchNumbers,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: params.competitorPriceControlParameterPc,
            countPriceBySkuWithoutBatches: params.countPriceBySkuWithoutBatches,
            thompsonSampling: params.thompsonSampling,
            priceDecreaseLimit: params.priceDecreaseLimit,
            kviPriceDecreaseLimit: params.kviPriceDecreaseLimit,
            purchasePriceSuppliersMinProfitForKVI: params.purchasePriceSuppliersMinProfitForKVI,
            compPriceDecreaseLimit: params.compPriceDecreaseLimit,
            backBasketPart: params.backBasketPart,
            useArrivalDate: params.useArrivalDate,
            useEmptyRemains: params.useEmptyRemains,
            countByAvgPurchasePrice: params.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: params.calcPurchasePriceByClusters,
            revaluationCalculateParams: params.revaluationCalculateParams,
            checkMarginDeclineProfit: params.checkMarginDeclineProfit,
            declineProfitabilityPc: params.declineProfitabilityPc,
            searchPreviousPricesDepth: params.searchPreviousPricesDepth,
            compensateLowerTargets: params.compensateLowerTargets,
            inflation: params.inflation,
            calculateBySpeedSale: params.calculateBySpeedSale,
            purchasePriceSuppliersMinProfit: params.purchasePriceSuppliersMinProfit,
            percentageOfRecommendsKviCount: params.percentageOfRecommendsKviCount,
            useSegmentsPriceInSearchKVIRecParam: params.useSegmentsPriceInSearchKVIRecParam,
            saveKviSign: params.saveKviSign,
            useCompetitorsForKviRecommends: params.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: params.competitorsPeriodForKviRecommends,
            purchasePriceSuppliersMinProfitForCompetitors: params.purchasePriceSuppliersMinProfitForCompetitors,
            purchasePriceSuppliers: params.purchasePriceSuppliers,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments)!!,
            isFixPricePromo: params.isFixPricePromo,
            spreadByPriceSegments: params.spreadByPriceSegments,
            useFixedPrices: params.useFixedPrices,
        };
    }

    priceGapCtmPcValidate(priceGapCtm: number): boolean {
        return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
    }

    get saveState(): boolean {
        return !((this.$scenario.groupOfProduct != null && this.$scenario.groupOfProduct > 0)
                || (this.$scenario.categoryOfProduct != null && this.$scenario.categoryOfProduct > 0))
    }

    paramsSum(uvwParams: UVWSpreadParams): boolean {
        const u = uvwParams.u;
        const v = uvwParams.v;
        const w = uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    paramsSumXYZ(xyzParams: XYZSpreadParams): boolean {
        const x = xyzParams.x;
        const y = xyzParams.y;
        const z = xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    calculationDepthValidate(calculationDepth: number, calculationDay: number): boolean {
        return calculationDepth * 7 >= calculationDay;
    }

    calculationDayValidate(calculationDay: number): boolean {
        return calculationDay > 0;
    }

    priceIncreaseLimitValidate(priceIncreaseLimit: number): boolean {
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    priceDecreaseLimitValidate(priceDecreaseLimit: number): boolean {
        return priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    backBasketPartValidate(backBasketPart: number): boolean {
        return backBasketPart >= 0 && backBasketPart <= 100;
    }

    kviPriceDecreaseLimitValidate(kviPriceDecreaseLimit: number): boolean {
        return kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
    }

    compPriceDecreaseLimitValidate(compPriceDecreaseLimit: number): boolean {
        return compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
    }

    competitorsPricesValidate(competitorsPrices: number): boolean {
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsPrices.toString());
    }

    marginalPriceDifferenceValidate(marginalPriceDifference: number): boolean {
        if (marginalPriceDifference != null) {
            return marginalPriceDifference >= 0 && marginalPriceDifference <= 100;
        }
        return false;
    }

    marginalProfitabilityValidate(marginalProfitability: number): boolean {
        if (marginalProfitability < 0) {
            this.marginalSkuErrorText = this.$t('regular.validation.negativeProfit') as string
        } else {
            this.marginalSkuErrorText = ''
        }
        return marginalProfitability < 100;
    }

    competitorsMinProfitValidate(competitorsMinimumProfit: number): boolean {
        return competitorsMinimumProfit.toString() !== '';
    }

    daysToPriceChangeStartValidate(params: ScenarioAnalysisParams): boolean | null {
        if (params.daysToPriceChangeStart == null || params.daysToPriceChangeStart === 0) {
            return null; // null означает, что поле не заполнено (опциональное)
        }
        return params.daysToPriceChangeStart > 0;
    }

    daysToPriceChangeFinishValidate(params: ScenarioAnalysisParams): boolean | null {
        if (params.daysToPriceChangeFinish == null || params.daysToPriceChangeFinish === 0) {
            return null; // null означает, что поле не заполнено (опциональное)
        }
        if (params.daysToPriceChangeFinish <= 0) {
            return false;
        }
        // Проверяем, что finish >= start, если оба заполнены
        if (params.daysToPriceChangeStart != null && params.daysToPriceChangeStart > 0) {
            return params.daysToPriceChangeFinish >= params.daysToPriceChangeStart;
        }
        return true;
    }

    setNonNegativeInteger(input: string): string {
        const parsed = parseInt(input, 10);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return '0';
        }
        return parsed.toString();
    }

    priceGapValidate(priceGap: number): boolean {
        return priceGap.toString() !== '' && priceGap >= 0;
    }

    minProfitKVIValidate(minProfitKVI: number): boolean {
        return minProfitKVI.toString() !== '' && minProfitKVI >= -50 && minProfitKVI <= 500;
    }

    marginalProfitValidate(marginalProfit: number): boolean {
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('regular.validation.negativeProfit') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    priceChangeLimitValidate(priceChangeLimit: number): boolean {
        return priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    periodPriceIncreaseLimitValidate(periodPriceIncreaseLimit: number): boolean {
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    inputInterval(intervalOfUltimateElasticity: IntervalOfUltimateElasticity): boolean {
        const lowerI = intervalOfUltimateElasticity.lower.toString();
        const upperI = intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    inputIntervalP(priceCorridor: PriceCorridor, changePriceCorridor: boolean): boolean {
        if (this.isDisabledPriceBorder(changePriceCorridor)) {
            return true;
        }
        if (this.$scenario.selectMarket.id === -1 || this.$scenario.categoryOfProduct == null) {
            return false;
        }
        const lowerI = priceCorridor.min.toString();
        const upperI = priceCorridor.max.toString();
        if (priceCorridor.min >= priceCorridor.max || priceCorridor.min >= priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    correlationCheck(correlation: number): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const correlationStr = correlation.toString();
        if (correlationStr.length === 0 || !numberPattern.test(correlationStr)) {
            if (this.$scenario.selectMarket != null) {
            }
            return false;
        }
        const cor = parseFloat(correlationStr);
        return 1 >= cor && cor >= -1;

    }

    highElasticityCheck(highElasticity: number): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticityStr = highElasticity.toString();
        this.$log.debug(highElasticityStr.length > 0, numberPattern.test(highElasticityStr));
        return numberPattern.test(highElasticityStr);
    }

    isDisabledPriceBorder(changePriceCorridor: boolean): boolean {
        return !changePriceCorridor;
    }

    competitorPriceControlParameterPcValidate(competitorPriceControlParameterPc: number): boolean {
        return competitorPriceControlParameterPc.toString() !== '' && competitorPriceControlParameterPc > 0 && competitorPriceControlParameterPc <= 100;
    }

    saveTempScenario(scenario: ScenarioNameWithParams) {
        this.tempScenario = scenario
    }

    marginalProfitDeclinePcValidate(declineProfitabilityPc: number): boolean {
        return declineProfitabilityPc != null && declineProfitabilityPc < 100;
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    get isCategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$scenario.categoryOfProduct != null && this.$scenario.categoryOfProduct!! > 0;
    }

    get isGroupSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$scenario.groupOfProduct != null && this.$scenario.groupOfProduct!! > 0;
    }

    get isSubcategoriesSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$scenario.subcategories.length != null && this.$scenario.subcategories.length!! > 0;
    }

    get scenarioNameEmptyValidate(): boolean {
        if (this.scenarioNameIsUnique()) {
            this.scenarioNameIsUniqueErrorText = this.$t('regular.validation.scenarioNameUnique') as string
        } else {
            this.scenarioNameIsUniqueErrorText = ''
        }
        return !this.scenarioNameIsEmpty();
    }

    get scenarioNewNameEmptyValidate(): boolean {
        if (this.scenarioNewNameIsUnique()) {
            this.scenarioNewNameIsUniqueErrorText = this.$t('regular.validation.enterUniqueName') as string
        } else {
            this.scenarioNewNameIsUniqueErrorText = ''
        }
        return !this.scenarioNewNameIsEmpty();
    }

    get isAllowCreateScenario(): boolean {
        return (this.$scenario.categoryOfProduct != null && this.$scenario.categoryOfProduct > 0)
            && this.$scenario.formatSelected !== null
            && !!this.$scenario.regionSelected[0]
            && (this.taskInfo.clusterOptions.length < 2 || this.$scenario.clusterSelected !== null);
    }

    get enableDepthToPurchasePrice(): boolean {
        return (this.$scenario.countByAvgPurchasePrice && this.$scenario.useArrivalDate) || (!this.$scenario.countByAvgPurchasePrice && !this.$scenario.countAtMaxPurchasePrice);
    }

    decreaseSalesCountValidate(decreaseSalesCountValue: number): boolean {
        return decreaseSalesCountValue != null && decreaseSalesCountValue >= 0 && decreaseSalesCountValue < 100;
    }

    percentageOfRecommendsKviValidate(percentageOfRecommendsKviCount: number): boolean {
        const kviRecommends = percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    private getSkuFilter(): SkuFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();

        return {
            category: this.$scenario.categoryOfProduct,
            storeCluster: this.$scenario.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$scenario.formatSelected,
            tradingId: this.$scenario.selectMarket.id,
            calculationDepth: this.$scenario.calculationDepth,
            calculationDay: this.$scenario.calculationDay,
            skuFilter: '',
            groupOfProduct: this.$scenario.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$scenario.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: undefined,
            kvi: undefined,
            priceCorridor: this.$scenario.priceCorridor,
            changePriceCorridor: this.$scenario.changePriceCorridor,
            needCalculateSku: undefined,
            needCalculateSkuLastPricesOnly: undefined,
            needCalculateSkuActualProfitabilityOnly: undefined,
            kviRecommendation: undefined,
            productSegments: LocalData.filterNumberArrays(this.$scenario.productSegments),
            keyCharacteristicOfTheProductIsOne: undefined,
            keyCharacteristicOfTheProductIsTwo: undefined,
            recipeAttributes: undefined,
            treatmentAttributes: undefined,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: undefined,
            productRangeFilter: undefined,
            countAtMaxPurchasePrice: this.$scenario.countAtMaxPurchasePrice,
        };
    }
}
